import moment from "moment/moment";

export default function (
  orderListData,
  orderAmountField,
  orderCountField,
  minCol = 12
) {
  const toNumber = (value) => +parseFloat(value || 0).toFixed(2);
  const orderList = orderListData || [];
  const labels = [];
  const datasets = [
    {
      label: "Order Value",
      fill: true,
      borderColor: "#002872",
      backgroundColor: "#002872",
      pointBorderColor: "#002872",
      borderWidth: 3,
      yAxisID: "y",
      data: [],
    },
    {
      label: "Order Count",
      fill: true,
      borderColor: "var(--primary)",
      backgroundColor: "var(--primary)",
      pointBorderColor: "var(--primary)",
      borderWidth: 3,
      yAxisID: "y1",
      data: [],
    },
  ];
  if (orderList && orderList.length > 0) {
    let lastKnownTime = moment();
    orderList.forEach((x) => {
      labels.push(`${x.date}`);
      lastKnownTime = `${x.date}`;
      datasets[0].data.push(toNumber(x[orderAmountField]));
    });
    orderList.forEach((y) => {
      datasets[1].data.push(toNumber(y[orderCountField]));
    });
    if (datasets[0].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[0].data.length)
        .fill(0)
        .forEach(() => {
          labels.unshift(lastKnownTime.add(-1, "days").format("YYYY-MM-DD"));
          datasets[0].data.unshift(0.0);
        });
    }
    if (datasets[1].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[1].data.length)
        .fill(0)
        .forEach(() => {
          datasets[1].data.unshift(0.0);
        });
    }
  }
  return {
    labels,
    datasets,
  };
}
